<template>
    <div class="biz-contract-default">
        <biz-contract-pdf v-if="$route.query.file === 'pdf'"></biz-contract-pdf>
        <biz-contract v-else></biz-contract>
    </div>
</template>
<script>
import bizContract from '@/components/bussiness/mgtCategory/bookingMgt/bizContract/bizContract';
import bizContractPdf from '@/components/bussiness/mgtCategory/bookingMgt/bizContract/bizContractPdf';

import { mapGetters } from 'vuex'
export default {
    data () {
        return {
        }
    },
    watch: {
        $route:{
            handler: function (val) {
            },
            // immediate: true,
            deep: true
        }
    },
    methods: {
    },
    computed: {
        ...mapGetters({
            isModalMode: 'GET_MODAL_MODE'
        })
    },
    components: {
        bizContract,
        bizContractPdf
    }
}
</script>
<style lang="scss" scoped>
    .biz-contract-default{
    }
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/mgtCategory/bookingMgt/bizContractDefault.vue